import ScanViewModel from "@/domain/scan/ScanViewModel";
import ClientBase from "../ClientBase";
import CreateScanResponse from "@/domain/scan/CreateScanResponse";

class ScanClient extends ClientBase {
    async getScanById(assetId, scanId) {
        const data = await this.get(`api/v1/scans/assets/${assetId}/scans/${scanId}`);
        return data ? new ScanViewModel(data) : null;
    }

    async getScansByAssetId(assetId) {
        const data = await this.get(`api/v1/scans/assets/${assetId}`);
        return data?.map(scan => new ScanViewModel(scan)) ?? [];
    }

    async createScanRecord(scanRecord) {
        const data = await this.post('api/v1/scans', scanRecord);
        return data ? new CreateScanResponse(data) : null;
    }

    async startScanGeneration(request) {
        return await this.put('api/v1/scans/events/processing', request);
    }

    async updateScanSourceFileUploadStatus(request) {
        return await this.put('api/v1/scans/events/source-file-uploaded', request);
    }

    // Persists the client-computed point-cloud perimeter (local-coords JSON string) against a scan.
    async updateScanPerimeter(assetId, scanId, perimeterJson) {
        return await this.put(`api/v1/scans/assets/${assetId}/scans/${scanId}/perimeter`, { perimeterJson });
    }
}

export default new ScanClient();